// Interface

import util from '@/utils/classToObject'
import { IUmbClasseState } from './state'
import { AloDbUmbClasse } from '@/models/alodb/AloDbUmbClasse'

export class UmbClasseGetter {  
      
  public umbClasses(state:IUmbClasseState,getters:any) {
    return state.umbClasses
  }

  public modifiedAdmUmbClasse(state:IUmbClasseState,getters:any) {
    return state.modifiedAdmUmbClasse
  }

  public originalAdmUmbClasse(state:IUmbClasseState,getters:any) {
    return state.originalAdmUmbClasse
  }

  public umbClasseLoading(state:IUmbClasseState,getters:any) {
    return state.umbClasseLoading
  }

  public umbClassesById(state:IUmbClasseState) {     
    return state.umbClasses.reduce((acc,value) =>{
        acc[value.UMC_ID!] = value
        return acc
    },{}  as {[id:number]:AloDbUmbClasse})      
  }

  public umbClasseStatus(state:IUmbClasseState) {     
    return state.status
  }

  public adminUmbClasseFilter(state:IUmbClasseState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(UmbClasseGetter)